import * as React from "react";
import { Offcanvas } from "react-bootstrap";
import { DriveUIActionTypes, WatchedSidePanelProps, PanelState, getEntityIcon } from "src/common";
import { Icon } from "src/components";
import { ItemDetails, ItemChanges } from "./side-panel";


function SidePanelComponent(props: WatchedSidePanelProps) {
  const { entry, panel_state, handleAction } = props;

  // Description: Close the offcanvas and reset current entry - send undefined for entry to reset parent state
  function handleClose() {
    handleAction({ actionType: DriveUIActionTypes.ToggleSidePanel, params: PanelState.off });
  }

  return (
    <Offcanvas
      className="sidebar watched-details"
      backdrop={false}
      show={panel_state === PanelState.on}
      onHide={handleClose}
      placement="end" >
      <Offcanvas.Header closeButton >
        <Offcanvas.Title className="title-div">
          <span>
            <Icon className={entry.type_class || getEntityIcon(entry.type)} />
          </span>
          <p>{entry.name}</p>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <ItemDetails  {...props} />
        <ItemChanges {...props} />
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default React.memo(SidePanelComponent);
